import { ApiResponse } from '../models/common.model'
import {
  IAddIssuedCheck,
  IEditIssuedCheck,
  IGetAccountsByClient,
  IGetClientInfoByUser,
  IGetIssuedCheckFile,
  ISubmitIssuedCheckFile,
  IGetIssuedCheckProcessingPayload
} from '../models/issuedCheck.model'
import customAxios from '../utils/api-util/customAxios'
import { IViewErrorPayload } from '../models/issuedCheckProcessingLog.model'
import axiosInstance from '../utils/api-util/utilApi'

const transactionConfig = { baseURL: process.env.REACT_APP_TRANSACTION_SERVICE_URL || '' }
const clientConfig = { baseURL: `${process.env.REACT_APP_CLIENT_SETUP_SERVICE_URL}/api` || '' }

export const addNewIssuedCheck = (payload: IAddIssuedCheck.Payload): Promise<ApiResponse<IAddIssuedCheck.Response>> => {
  return axiosInstance.post(`/issuedChecks/add`, JSON.stringify(payload), transactionConfig)
}

export const getAccountsByClient = (
  payload: IGetAccountsByClient.Payload,
): Promise<ApiResponse<IGetAccountsByClient.Response>> => {
  return axiosInstance.get(`/clients/${payload.clientId}/clientInfo`, clientConfig)
}

export const getClientInfoByUser = (
  payload: IGetClientInfoByUser.Payload,
): Promise<ApiResponse<IGetClientInfoByUser.Response>> => {
  return axiosInstance.get(`/clients/clientInfo/${payload.clientUserId}`, clientConfig)
}

export const submitIssuedCheckFile = (
  formData: ISubmitIssuedCheckFile.Payload,
): Promise<ApiResponse<ISubmitIssuedCheckFile.Response>> => {
  return customAxios('multipart/form-data').post(`/issuedChecks/submitFile`, formData, transactionConfig)
}

export const getIssuedCheckFile = (
  payload: IGetIssuedCheckFile.Payload,
): Promise<ApiResponse<IGetIssuedCheckFile.Response>> => {
  return axiosInstance.get(`/issuedChecks/lastSubmitFile/${payload.userId}`, transactionConfig)
}

export const getIssuedCheckProcessingResult = (payload: IGetIssuedCheckProcessingPayload) => {
  return axiosInstance.post(`/IssuedCheckProcessingLog/filter`, JSON.stringify(payload), transactionConfig)
}

export const getDetailIssuedCheckProcessing = (payload: IViewErrorPayload) => {
  return axiosInstance.post(`/IssuedCheckProcessingLog/viewDetail`, JSON.stringify(payload), transactionConfig)
}

export const downloadFileFromIssuedCheck = (id: string) => {
  return axiosInstance.get(`/IssuedCheckProcessingLog/downloadSubmitFile/${id}`, transactionConfig)
}

export const editIssuedCheck = (payload: IEditIssuedCheck.Payload): Promise<ApiResponse<any>> => {
  return axiosInstance.put(`/issuedChecks/edit`, JSON.stringify(payload), transactionConfig)
}

export const deleteIssuedCheck = (id: string): Promise<ApiResponse<any>> => {
  return axiosInstance.delete(`/issuedChecks/delete/${id}`, transactionConfig)
}
